module.exports = __webpack_public_path__ + "img/us.a3f2efe2.svg";